import * as React from 'react';

import { connect } from 'react-redux';
import { trackEvent } from '../analytics/tracking';
import FilteredDispensaries from './FilteredDispensaries';
import Spinner from '../common/Spinner';
import PropTypes from 'prop-types';

import styles from '../dispensaries/Dispensaries.module.css';

const DispensariesList = ({
  onLoad,
  deliveryAddress,
  anonymousZipCode,
  dispensaries=[]
}) => {
  
  /**
   * This currently just logs whether a dispensary was found that could
   * deliver to a user's zip code.  This will need updating when we 
   * implement the address typeahead 
   * 
   * @param {*} zipCode 
   * @param {*} dispensaries 
   * @param {*} onLoadFn 
   */
  const assignDefaultDispensary = (zipCode, dispensaries, onLoadFn) => {
    // Find a dispensary that can service the user's zip code
    const [ deliveryEnabledDispensary ] = dispensaries.filter(disp => {
      const delivery_zip_codes = disp.delivery_zip_codes || [];
      return delivery_zip_codes.indexOf(zipCode) > -1
    });
    // Fall back to the first dispensary if needed
    const defaultDispensary = deliveryEnabledDispensary || dispensaries[0];
    
    const trackingLabel = deliveryEnabledDispensary 
           ? 'dispensaryFoundForZip'
           : 'dispensaryNotFoundForZip';
    trackEvent(trackingLabel, zipCode);
   
    // return the default dispensary info to the host page (for use in Shop by Product, etc.)
    // TODO: set the default in redux?
    if (onLoadFn) {
      onLoadFn(defaultDispensary.id, !!deliveryEnabledDispensary);
    } 
  };

  const [zipCode, setZipCode] = React.useState('-1'); // might need initial value to trigger default dispensary.
  
  React.useEffect(() => {
    // Get curerent zip code from redux
    const newZipCode = deliveryAddress.zip_code || anonymousZipCode;
    if (newZipCode !== zipCode) {
      setZipCode(newZipCode);
    }
    if (dispensaries && dispensaries.length) {
      assignDefaultDispensary(newZipCode, dispensaries, onLoad);
    }
  }, [anonymousZipCode, deliveryAddress.zip_code, dispensaries, onLoad, zipCode]);

  // content fades in on render
  const fader = React.createRef();
  const loading = dispensaries.length === 0;
    
  const wrapClass = loading ? styles.fadeWrapper : `${styles.fadeWrapper} ${styles.fadeIn}`;
  
  return (
    <>
      <div className={wrapClass} ref={fader}>
        {/* deliverable */}
        { zipCode &&
          <FilteredDispensaries showMatching zipCode={zipCode} dispensaries={dispensaries} />
        }
        {/* pickup only */}
        <FilteredDispensaries showMatching={false} zipCode={zipCode} dispensaries={dispensaries} />
      </div>
      { loading &&
        <Spinner />
      }
    </>
  )
}

DispensariesList.propTypes = {
  onLoad: PropTypes.func,
  // redux
  deliveryAddress: PropTypes.object,
  anonymousZipCode: PropTypes.string,
  dispensaries: PropTypes.array
}

const mapStateToProps = (state)=>{
  return {
    deliveryAddress: state.delivery_address,
    anonymousZipCode: state.anonymous_zip_code,
    dispensaries: state.dispensaries
  }
}

export default connect(mapStateToProps)(DispensariesList)